import { ITimeEntry } from "../../Data/Models/ITimeEntry";

export class ForgottenTimeEntryContextModel {
	modalTimeEntry?: ITimeEntry;
	constructor(mcm?: Partial<ForgottenTimeEntryContextModel>) {
		Object.assign(this, mcm);
	}
}
